import { findChildren } from '@tiptap/core';
import type { Transaction } from '@tiptap/pm/state';

export const findNodeById = (tr: Transaction, id: string) => {
  return findChildren(tr.doc, node => node.attrs.id === id);
};
